import script from "./MapVRAK.vue?vue&type=script&setup=true&lang=ts"
export * from "./MapVRAK.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__